(function () {
  'use strict';

  /* ---------- duplicate contact form id ---------- */
  /* {% form 'contact' %} hardcodes id="contact_form" on the <form> itself --
     harmless with one contact form per page (every other page on this site
     has only one), but this page has two (project intake + installer
     search), producing invalid duplicate-id HTML. Renames every form after
     the first so each stays uniquely addressable. */
  var contactForms = document.querySelectorAll('#contact_form');
  contactForms.forEach(function (form, index) {
    if (index > 0) {
      form.id = 'contact_form_' + (index + 1);
    }
  });

  /* ---------- 07 free installer search ---------- */
  /* "What's being installed?" is a multi-select (checkboxes), but Shopify's
     contact form only accepts flat key/value fields, so the checked labels
     are joined into one hidden contact[installing] field on every change.
     Same pattern as pds-calculator.js's sizing chips on the Pool Calculator
     page's help form. */
  var installingChips = document.querySelectorAll('[data-install-chip]');
  var installingValue = document.querySelector('[data-install-value]');
  if (installingChips.length && installingValue) {
    var syncInstalling = function () {
      var checked = [];
      installingChips.forEach(function (chip) {
        if (chip.checked) checked.push(chip.value);
      });
      installingValue.value = checked.join(', ');
    };
    installingChips.forEach(function (chip) {
      chip.addEventListener('change', syncInstalling);
    });
    syncInstalling();
  }
})();
